module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.3885/images/bootcamps-card-thumbnail.webp"